module.exports = __webpack_public_path__ + "img/wallet_02_fiat_2.a716a6c8.png";